import { useNavigate } from "react-router";
import { twMerge } from "tailwind-merge";
import { CardImage } from "@sellar-io/components";
import { SPOTLIGHT } from "../../../constants/routes";
import { useGetSpotlightPageData } from "../Spotlight.shared";

export const SpotlightListCollectionCard = ({
  pageId,
  type,
}: {
  pageId: string;
  type: "product style" | "regional";
}) => {
  const navigate = useNavigate();
  const { data: currentPage } = useGetSpotlightPageData(pageId);
  return (
    <div
      className={twMerge("flex h-auto w-full flex-col gap-4 lg:w-[300px]")}
      onClick={() =>
        navigate(`${SPOTLIGHT.href({ spotlightId: pageId })}?type=${type}`)
      }
    >
      <div className={twMerge("flex cursor-pointer flex-col")}>
        <div
          className={twMerge(
            "relative h-[120px] cursor-pointer gap-0 overflow-clip rounded-t-lg bg-white",
          )}
        >
          <CardImage
            imageUrl={
              currentPage.bannerLargeUrl ?? currentPage.bannerMediumUrl ?? ""
            }
            fallback="product-hero"
            className={twMerge("h-[120px] w-[300px] rounded-t-lg")}
          />
        </div>
        <div className="flex flex-col rounded-b-lg bg-white p-4">
          <p className={"line-clamp-1 text-sm font-semibold text-zinc-800"}>
            {currentPage.title}
          </p>
          <p className={"line-clamp-2 text-sm font-normal text-zinc-500"}>
            {currentPage.description}
          </p>
        </div>
      </div>
    </div>
  );
};
